import React from "react";

import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoute from "./routes/AppRoute";

class App extends React.Component {

  render() {
    return (
      
      <BrowserRouter>
        <div className="main-component">
          <AppRoute />
        </div>
      </BrowserRouter >
    )
  }

}

export default App;